"use client";

import React from "react";
import {ColletteIconButton} from "@collette-travel/collette-common-controls";
import {Stack, Typography} from "@mui/material";
import {Close} from "@mui/icons-material";

interface OnTourAirModalProps {
  header: string;
  description: string;
  handleClose: () => void;
}

const OnTourAirModal = ({
  header,
  description,
  handleClose
}: OnTourAirModalProps) => (
  <Stack
    sx={{
      borderRadius: "1rem",
      backgroundColor: "background.default",
      overflow: "hidden",
      padding: {xs: "2.4rem", sm: "4rem", md: "4rem 6rem"},
      width: {xs: "auto", md: "70rem"},
      gap: "2.4rem"
    }}
    data-testid="on-tour-air-modal-container"
  >
    <ColletteIconButton
      testId="on-tour-air-modal-close-button"
      onClick={handleClose}
      sx={{
        mt: "-0.8rem",
        mr: "-0.8rem",
        position: "absolute",
        top: 24,
        right: 24
      }}
    >
      <Close />
    </ColletteIconButton>

    <Typography
      component="p"
      variant="h5"
      data-testid="on-tour-air-modal-header"
      sx={{
        mr: "3rem"
      }}
    >
      {header}
    </Typography>

    {/* Description */}
    <div
      style={{
        fontSize: "1.6rem"
      }}
      data-testid="on-tour-air-modal-description"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{__html: description}}
    />
  </Stack>
);

export default OnTourAirModal;